var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    rx: 76,
    fill: "#FAFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9941 89.6997V116.82H40.9941V103.58C40.9941 95.9197 47.0841 89.6997 54.5941 89.6997H63.0041H62.9941Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.463 116.82H45.4434V103.58C45.4434 95.9197 51.6534 89.6997 59.3234 89.6997H98.8134C106.473 89.6997 110.463 95.9097 110.463 103.58V116.82Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1431 54.9896H55.1631C55.6531 43.4096 65.6531 34.2896 77.5431 35.2496C87.6631 36.0596 95.7931 44.2996 96.4831 54.4296C96.9831 61.8296 93.5931 68.4796 88.1531 72.5096V84.5096H62.6731V76.5796H59.4631C56.8331 76.5796 54.7031 74.4496 54.7031 71.8196V64.1596H52.8531C51.6731 64.1596 50.8931 62.9396 51.3831 61.8696L55.1531 54.9996L55.1431 54.9896Z",
    fill: "#E6E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7442 71.4596C84.2604 71.4596 91.1642 64.5559 91.1642 56.0396C91.1642 47.5234 84.2604 40.6196 75.7442 40.6196C67.228 40.6196 60.3242 47.5234 60.3242 56.0396C60.3242 64.5559 67.228 71.4596 75.7442 71.4596Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3437 55.3029C83.5951 54.1387 82.4218 49 77.4347 49C76.2195 49 73.5207 49.6504 72.4479 52.2518C70.71 51.6093 69.0115 52.9905 69.0115 55.3029C68.355 55.5037 67 55.5106 67 57.6715C67 59.8325 68.6902 59.8127 69.5562 60H83.3437C85.2958 59.6905 85.7944 55.3029 83.3437 55.3029Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.144 92.3195H60.334C59.784 92.3195 59.334 91.8695 59.334 91.3195V86.4995C59.334 85.3995 60.234 84.4995 61.334 84.4995H68.484L63.144 92.3195Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9748 92.3195H89.1048C89.6548 92.3195 90.1048 91.8695 90.1048 91.3195V86.4995C90.1048 85.3995 89.2048 84.4995 88.1048 84.4995H68.6348L73.9748 92.3195Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1448 116.82L70.3048 93.6495L72.2148 89.7495L68.6348 84.4995L64.8848 89.7695L67.1348 93.6495L64.8848 116.82H73.1448Z",
    fill: "#8E8CEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.893 89.6997H98.8131C93.2331 89.6997 88.7031 95.9097 88.7031 103.58V116.82H111.003V103.58C111.003 95.9197 106.483 89.6997 100.893 89.6997Z",
    fill: "#E6E5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 105H51V108H60V105Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMental);
export default __webpack_public_path__ + "static/media/mental.89b237e9e1e52ecc0391d965364fbfc3.svg";
export { ForwardRef as ReactComponent };